import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-combobox',
	templateUrl:'./WaComboboxProPage.html',
	styles: [],
	styleUrls:['./WaComboboxProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaComboboxProPage
{
	mdContent_314 = `\`\`\`java
import com.jwebmp.webawesomepro.components.combobox.WaCombobox;
\`\`\``;
	mdContent_315 = `\`\`\`java
new WaCombobox<>()
\`\`\``;
	mdContent_316 = `\`\`\`java
new WaCombobox<>(String placeholder)
\`\`\``;
	mdContent_317 = `\`\`\`java
var combo = new WaCombobox<>("Search items");
combo.add(new WaSelectOption<>("item1", "Item 1"));
combo.add(new WaSelectOption<>("item2", "Item 2"));
combo.add(new WaSelectOption<>("item3", "Item 3"));
\`\`\``;
	mdContent_318 = `\`\`\`java
var combo = new WaCombobox<>("Tags");
combo.setMultiple(true);
combo.setClearable(true);
combo.add(new WaSelectOption<>("java", "Java"));
combo.add(new WaSelectOption<>("angular", "Angular"));
combo.add(new WaSelectOption<>("vertx", "Vert.x"));
\`\`\``;
}
